<template>
    <div class="pageContainer">

        <b-breadcrumb class="breadCrumb">
            <b-breadcrumb-item href="#home" @click="goBackToCampaignList">
                
              <b-icon icon="card-list"></b-icon>

                Campaigns List
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="flagUpdate" active>Update</b-breadcrumb-item>
            <b-breadcrumb-item v-if="flagCreate" active>Create</b-breadcrumb-item>

        </b-breadcrumb>
        
        <div class="card bg-dark shadow border-0">

            <b-form action="" class="form">
                <label for="name-create">Name</label>
                <input v-model="campaign.name" type="text" id="name-create" ref="name">

                <label for="startDate-create">Start Date</label>
                <input v-model="campaign.startDate" type="date" id="startDate-create" ref="startDate">

                <label for="endDate-create"> End Date</label>
                <input v-model="campaign.endDate" type="date" id="endDate-create" ref="endDate">
                <label for="multiselect"></label>

                <label for="alTenants">Tenant:</label>
                <Multiselect :options="authors" class="multiS" label="name" v-model="tenant" id="allTenants"
                    placeholder="Select Name">
                </Multiselect>

                <label for="redirectUrl"> redirect URL</label>
                <input v-model="campaign.redirectUrl" type="text" id="redirectUrl">

                <label for="allVideos"> Campaign Videos:</label>
                <Multiselect id="allVideos" class="multiS" v-model="DisplayVideosArray"
                    placeholder="Select Multiple Videos" label="title" track-by="id" :options="AllVideos"
                    :clear-on-select="false" :close-on-select="false" :multiple="true">
                </Multiselect>

                <div class="displayVideos mt-3">
                    <div class="col-md-3 mb-3" v-for="video in DisplayVideosArray" :key="video.id">
                        <div class="video-item">
                            <div class="video-image mb-2">
                                <img :src="video.thumbnail" :alt="video.title" width="100%">
                            </div>
                            <div class="video-title">{{ video.title }}</div>
                        </div>
                    </div>
                </div>



            </b-form>
            <div v-if = "errors">
                <ul>
                    <li v-for="item in errors" class="errors">{{ item.message }} </li>
                </ul>
            </div>


        </div>


        <div class="buttonContainer">
            
            <b-button v-if="flagCreate" @click="createCampaign" style="border-radius:5px;" variant="success">
        
                Create
            </b-button>
            <b-button v-if="flagUpdate" @click="updateCampaign(id)" style="border-radius:5px;" variant="success">
                Update
            </b-button>
        
            <b-button v-if="flagUpdate" variant="danger" @click="showModal" class=" deleteButton ml-2">
        
                Delete
            </b-button>
        </div>
        
        <!-- <b-modal hide-footer class="deleteModal" id="deleteModal" ref="deleteModal" :modal-class="myModalClass">
            <div class="deleteAlert">
                Are you sure you want to delete this Campaign ?
            </div>
            <b-button @click="hideModal">
                Cancel
            </b-button>
            <b-button @click="deleteCamp" variant="danger" class="ml-1">
                Yes,Delete
            </b-button>
        </b-modal> -->
   
    </div>
</template>

<script>



import b2bService from "@/module_admin/api/b2b-admin-service";
import router from "@/router";

import Multiselect from "vue-multiselect";
import API from "../api.js"

export default {
    data() {
        return {
            id: this.$route.params.id,
            flagCreate: true,
            flagUpdate: true,
            campaign: {
                name: "",
                startDate: "",
                endDate: "",
                tenantId: 0,
                redirectUrl: "",
                config: "",
                campaignVideos: []
            },
            authors: [],
            errors: null,
            tenant: {
                id: 0, name: ''
            },
            AllVideos: [],
            DisplayVideosArray: [],
            authorReference: [],
            myModalClass:['deleteModal']
        }
    }

    , components: {
        Multiselect
    },
    methods: {
        hideModal() {
            this.$refs['deleteModal'].hide()
        },
        async deleteCamp() {
            try{
                let res = await API.deleteCampaign(this.id)
                if (res.status === 200) {
                    this.makeToast("success", "Campaign Deleted Succesfully")
                }
            } 
            catch(error){
                if (error.response.status === 500) {
                    this.makeToast("danger", "Failed to delete campaign")
                }
            }
        },
        makeToast(variant = null, content) {
            this.$bvToast.toast(content, {
                title: "Message",
                variant: variant,
                solid: true,

            })
        },
        developAuthorRefernce() {
            var id;
            for (let i = 0; i < this.authors.length; i++) {
                id = this.authors[i].id
                this.authorReference[id] = this.authors[i].name
            }
            return ("developedAuthorReference")
        },
        loadDropdownItems() {
            
            // this.developAuthorRefernce()
            return (1)

        },
        resetCampaign() {

            this.tenant = {
                id: 0,
                name: ""
            }
            this.campaign = {
                name: "",
                startDate: "",
                endDate: "",
                tenantId: 0,
                redirectUrl: "",
                config: "",
                campaignVideos: []
            }
            this.DisplayVideosArray = []

        },
        showModal(){
            this.$bvModal.msgBoxConfirm('Are you sure?',{
            title: 'Please Confirm',
           okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
            })
          .then(value => {

            if(value==true){
                this.deleteCamp(this.id)
            }

          })},
        
        async populateFields() {
            let res = API.getCampaignById(this.id)
            var result = {}
            await res.then((result1) => {
                console.log(result1)
                result = result1
            })
            this.campaign.name = result.data.name
            this.campaign.startDate = result.data.start_date
            this.campaign.endDate = result.data.end_date
            this.tenant.id = result.data.tenant_id
            this.campaign.redirectUrl = result.data.redirect_url
            this.campaign.config = result.data.config
            this.tenant.name = this.authorReference[result.data.tenant_id]
            this.DisplayVideosArray = result.data.CampaignVideos

        }
        , async deleteCampaign() {


        },
        async createCampaign() {

            console.log(this.DisplayVideosArray)
            this.campaign.tenantId = this.tenant.id
            this.campaign.campaignVideos = this.DisplayVideosArray
            const postData = this.campaign
            var flagValidDate = true
            var StartDate = postData.startDate //"2022-11-21"
            var EndDate = postData.endDate
            var startYear = StartDate.slice(0, 4)
            var endYear = EndDate.slice(0, 4)
            var startMonth = StartDate.slice(5, 7)
            var endMonth = EndDate.slice(5, 7)
            var startDate = StartDate.slice(8)
            var endDate = EndDate.slice(8)
               
            if (startYear > endYear) {
                flagValidDate = false
            }
            else if (startYear === endYear) {
                if (startMonth > endMonth) {
                    flagValidDate = false

                }
                else if (startMonth === endMonth) {
                    if (startDate > endDate) {
                        flagValidDate = false

                    }
                }
            }
            if (flagValidDate === false) {
                this.makeToast("danger", "Start Date Cannot Be Greater than End Date")
                return (0)
            }

        
            console.log(postData);
            
            try{
                let res = await API.createCampaign(postData)
                if (res.status == 200) {
                    this.makeToast("success", " Campaign  Created Successfully")
                }
                router.go(-1)
            }
            catch(error){
                this.errors = error.response.data.errorMessages;
            }
        },
        async updateCampaign(id) {
            if (id) {

                this.campaign.tenantId = this.tenant.id
                this.campaign.campaignVideos = this.DisplayVideosArray
                const putData = this.campaign;
                var flagValidDate = true
                var StartDate = putData.startDate //"2022-11-21"
                var EndDate = putData.endDate
                var startYear = StartDate.slice(0, 4)
                var endYear = EndDate.slice(0, 4)
                var startMonth = StartDate.slice(5, 7)
                var endMonth = EndDate.slice(5, 7)
                var startDate = StartDate.slice(8)
                var endDate = EndDate.slice(8)
                if (startYear > endYear) {
                    flagValidDate = false
                }
                else if (startYear === endYear) {
                    if (startMonth > endMonth) {
                        flagValidDate = false

                    }
                    else if (startMonth === endMonth) {
                        if (startDate > endDate) {
                            flagValidDate = false

                        }
                    }
                }
                if (flagValidDate === false) {
                    this.makeToast("danger", "Start Date Cannot Be Greater than End Date")
                    return (0)
                }
                try{
                    let res = await API.updateCampaign(id, putData)
                    if (res.status === 200) {
                        this.makeToast("success", " Campaign Details Updated Successfully")
                    }
                    router.go(-1)
                }
                catch(error){
                    if (error.response.status === 500) {
                        this.makeToast("danger", " Failed to update campaign details")
                    }
                }

                this.populateFields()
                
            }

        },
        async goBackToCampaignList() {
            router.go(-2)
        },
        async getUpdateDetails(){
            await b2bService.getProgramDropdownItems().then((resp) => {
                if (resp.code === 200) {
                    const data = resp.data;
                    this.authors = data.authors;
                    this.AllVideos = data.videos
                }
            })
            var id;
            for (let i = 0; i < this.authors.length; i++) {
                id = this.authors[i].id
                this.authorReference[id] = this.authors[i].name
            }
            this.populateFields()
        },

        async necessary(){
             
            //this.loadDropdownItems
            //this.popualteFields
            //the above Code Snippet will populate fields that is develop data when API call for get and bind data is develope before even developing authorReference which thereby develops incorrect data which is to be binded , where tenantName is not developed 
             
         // first get this.authors build up . Hence We need to use await otherWise this.authors would be empty and next part of code 
        //  will proceed with empty array which further won't let this.authorReference build which is used at this.populateFields
        if (this.$route.params.id === undefined) {
            b2bService.getProgramDropdownItems().then((resp) => {
                if (resp.code === 200) {
                    const data = resp.data;
                    this.authors = data.authors;
                    this.AllVideos = data.videos
                }
            })
            this.flagCreate = true
            this.flagUpdate = false

        }
        else {
            this.flagCreate = false
            this.flagUpdate = true
            this.getUpdateDetails()
            
        }   
        }
    },
     mounted() {
    this.necessary()    

    }
}
</script>

<style>
.deleteModal{
width: 50%;

}

    
</style>
<style scoped>
.card label,
.displayVideos {
    color: lightgoldenrodyellow;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

}

.card {
    padding: 10px;
    margin: 20px;
}

.deleteButton {
    margin: auto;

}

.multiS {
    background-color: white;
}

.form {
    display: flex;
    flex-direction: column;
}

.buttonContainer {
    margin: 20px;
}
.breadCrumb{
margin: 20px;
}
.pageContainer{
    margin:10px;
}
.modal-content{
    width: 50%;
    height: 50%;
    margin: auto;
}
.errors{
    
    margin: 0 20px ;
    color: red;
}

</style>